import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ComponentBase, DbaMatDialogFooterComponent, DialogData } from '@definitiv-packages/angular-dba-library';

import { DebitorModel, DebitorModelView, DebitorService, DebitorViewService, ObjektModel, ObjektModelView, ObjektService, ObjektViewService, ProjectLanguage, StandortModelView, StandortViewService } from '../../../../../roofsafetymanagement-library/src/public-api';
import { ActivatedRoute } from '@angular/router';
import { CreateObjektComponent } from '../../../../../roofsafetymanagement-library/src/lib/dialogs/create-objekt/create-objekt.component';
import { firstValueFrom } from 'rxjs';


@Component({
  selector: 'app-debtor-view',
  templateUrl: './debtor-view.component.html',
  styleUrl: './debtor-view.component.scss',
  standalone: false
})
export class DebtorViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public debtor: DebitorModelView | null = null;
  public objectList: ObjektModelView[] = [];
  public standortList: StandortModelView[] = [];

  constructor(
    private route: ActivatedRoute,
    private debtorService: DebitorViewService,
    private objectService: ObjektViewService,
    private matDialog : MatDialog,
    private standortViewService: StandortViewService
   
  ) { 
    super();
  }

    public async ngOnInit(): Promise<void> {
        var id = this.route.snapshot.params['debtorId'];
        if(!id) return;
        try {
            
            this.debtor = await this.debtorService.get(id);
            await this.loadData();

        } catch {
          this.loading = false;
        }
    }

    async loadData(){
      this.loading = true;
      try{
        var resultList = await Promise.all([
            this.objectService.getFilteredList({ DebitorID: this.debtor?.DebitorID }),
            this.standortViewService.getFilteredList({ DebitorID: this.debtor?.DebitorID })
        ]);
        this.objectList   = resultList[0].sort((a,b)=>{
              return(a.Bezeichnung! <b.Bezeichnung!)? -1:1        
        })
        this.standortList = resultList[1];
        this.loading = false;
      }catch{
        this.loading = false;
      }
    }

      public getObjektList (standortID : number){

          if(!standortID) return [];
          return this.objectList.filter(x=>x.StandortID == standortID)
      }

      public async openObjektDialog(debitor: DebitorModelView | null=null){

        var objekt :ObjektModelView = { 
            DebitorID : debitor?.DebitorID
        } 
          var data = new DialogData(objekt,'create' )
          var res = await firstValueFrom(this.matDialog.open(CreateObjektComponent, { data: data }).afterClosed());
          this.loadData();
      }
}
